import { render, staticRenderFns } from "./UnsavedModalPlugin.vue?vue&type=template&id=a17bd5ce&scoped=true"
import script from "./UnsavedModalPlugin.vue?vue&type=script&lang=js"
export * from "./UnsavedModalPlugin.vue?vue&type=script&lang=js"
import style0 from "./UnsavedModalPlugin.vue?vue&type=style&index=0&id=a17bd5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17bd5ce",
  null
  
)

export default component.exports